module.exports = __webpack_public_path__ + "static/dakkapel-1-b528affaec1021416a2f7f507579db95.jpg";